import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/chevron.svg';
import { Icon } from '../Icon/Icon';
const ChevronIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
export const ChevronUpIcon = (props) => <ChevronIcon direction="up" {...props}/>;
export const ChevronDownIcon = (props) => <ChevronIcon direction="down" {...props}/>;
export const ChevronLeftIcon = (props) => <ChevronIcon direction="left" {...props}/>;
export const ChevronRightIcon = (props) => <ChevronIcon direction="right" {...props}/>;
